import { useBrokerFirm } from '@queries/broker/useBrokerFirm';
import { isPreceptFinanceFirm } from '@utils/preceptFinanceFirm';

export function useCanAccessHppPages() {
  const { data: firm, isLoading: isFirmLoading } = useBrokerFirm();

  const hasHppPermission = firm?.hasHppPermissions === 'YES';
  const canAccess = hasHppPermission || isPreceptFinanceFirm(firm);

  return {
    canAccess,
    isLoading: isFirmLoading,
  };
}
